/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostClippingPastArticleResearchBillingBody
 */
export interface PostClippingPastArticleResearchBillingBody {
    /**
     * 企業ID
     * @type {number}
     * @memberof PostClippingPastArticleResearchBillingBody
     */
    companyId: number;
    /**
     * 過去記事検索の契約のID
     * @type {string}
     * @memberof PostClippingPastArticleResearchBillingBody
     */
    pastArticleSearchContractId: string;
}

export function PostClippingPastArticleResearchBillingBodyFromJSON(json: any): PostClippingPastArticleResearchBillingBody {
    return PostClippingPastArticleResearchBillingBodyFromJSONTyped(json, false);
}

export function PostClippingPastArticleResearchBillingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostClippingPastArticleResearchBillingBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'pastArticleSearchContractId': json['past_article_search_contract_id'],
    };
}

export function PostClippingPastArticleResearchBillingBodyToJSON(value?: PostClippingPastArticleResearchBillingBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'past_article_search_contract_id': value.pastArticleSearchContractId,
    };
}

